import { Page, Card, EmptyState, Text, BlockStack } from '@shopify/polaris';

export default function UnauthorizedAccess() {
  return (
    <Page>
      <Card>
        <BlockStack gap="400">
          <EmptyState
            heading="Unauthorized Access"
            image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
          >
            {/* <BlockStack gap="200">
              <Text as="p" variant="bodyMd">
                This is a Shopify embedded application and must be accessed through your Shopify Admin panel.
              </Text>
              <Text as="p" variant="bodyMd">
                Direct browser access is not permitted for security reasons.
              </Text>
              <Text as="p" variant="bodyMd" fontWeight="semibold">
                To access this app:
              </Text>
              <Text as="p" variant="bodyMd">
                1. Log in to your Shopify Admin
              </Text>
              <Text as="p" variant="bodyMd">
                2. Navigate to Apps
              </Text>
              <Text as="p" variant="bodyMd">
                3. Click on this app to launch it
              </Text>
            </BlockStack> */}
          </EmptyState>
        </BlockStack>
      </Card>
    </Page>
  );
}
